import React, { useEffect, useState } from "react";
import { Layout, Menu, Breadcrumb, Divider, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import docMenu from "./menu.json";
import "./docPage.css";

const { Content, Sider } = Layout;

export default function DocPage() {
  const [currentDocContent, setCurrentDocContent] = useState(undefined);
  const [activeDocPath, setActiveDocPath]         = useState("/doc/docHome");
  const [docLoaded, setDocLoaded]                 = useState(false);

  const { pathname } = useLocation();
  const navigate     = useNavigate();

  async function importAndExecDoc(path) {
    setDocLoaded(false);
    setCurrentDocContent(undefined);
    setActiveDocPath(path);

    try {
      const module = await import("./doc/js/" + path.split("/")[2] + ".js");
      setDocLoaded(true);
      setCurrentDocContent(module.default());
    } catch {
      setDocLoaded(true);
      setCurrentDocContent(<p className="doc-not-found">No Document Here!</p>);
    }
  }

  useEffect(() => {
    let normalized = pathname;
    if (/^\/doc\/?$/.test(pathname)) {
      normalized = "/doc/docHome";
      navigate("/doc/docHome", { replace: true });
      return;
    }
    importAndExecDoc(normalized);
  }, [pathname]);

  return (
    <div className="doc-frame">
      <Layout className="doc-layout">

        {/* Sidebar */}
        <Sider className="doc-sider" breakpoint="md" collapsedWidth="0" width={240}>
          <div className="doc-sider__inner">
            <Menu
              mode="inline"
              openKeys={[activeDocPath]}
              selectedKeys={[activeDocPath]}
              items={generateMenuItems(docMenu)}
              onClick={({ key }) => { setDocLoaded(false); navigate(key); }}
            />
          </div>
        </Sider>

        {/* Ana içerik */}
        <Layout className="doc-main">

          {/* Breadcrumb başlık */}
          <div className="doc-breadcrumb-bar">
            <LinkedBreadcrumb />
            <Divider className="doc-divider" />
          </div>

          {/* Markdown içerik */}
          <Content className="doc-content-area">
            <div className="doc-content-inner">
              {docLoaded ? (
                currentDocContent
              ) : (
                <div className="doc-loading">
                  <Spin size="large" />
                  <span>Loading documentation…</span>
                </div>
              )}
            </div>
          </Content>

        </Layout>
      </Layout>
    </div>
  );
}

function generateMenuItems(source) {
  const sorted = [...source].sort((a, b) => {
    if ("key" in a && "key" in b) return a.key - b.key;
    if ("key" in a) return -1;
    if ("key" in b) return  1;
    return a.title < b.title ? -1 : 1;
  });

  return sorted.map(menu => {
    menu.path = `/doc/${menu.name}`;
    return menu.children
      ? { key: menu.path, label: menu.title, children: generateMenuItems(menu.children) }
      : { key: menu.path, label: menu.title };
  });
}

function LinkedBreadcrumb() {
  const nameMap = new Map([
    ["/home",          "Home"],
    ["/doc",           "Documentation"],
  ]);
  for (const item of docMenu) nameMap.set(item.name, item.title);

  const { pathname } = useLocation();
  const parts        = pathname.split("/");

  const items = [
    { title: "Home",          href: "/#/home" },
    { title: "Documentation", href: "/#/doc"  },
  ];

  for (let i = 2; i < parts.length; i++) {
    items.push({
      title: nameMap.get(parts[i]) || parts[i],
      href:  "/#" + parts.slice(0, i + 1).join("/"),
    });
  }

  return <Breadcrumb items={items} />;
}
